<template>
  <div :class='componentClasses' :style='componentStyle'>
    <div class='result-wrapper'>
    <div class="result-description">
      <div class="result-prelude" v-if='config.title'>
        <h2>{{ $t(config.title, `options.components.${$attrs['data-index']}.options.title`) }}</h2>
      </div>
      <div class="result-question">
        <h2>{{ $t(config.text, `options.components.${$attrs['data-index']}.options.text`) }}</h2>
      </div>
    </div>

    <div class="result-data">
      <result-circle :config='circleConfig' :progress='progress' :title='circleTitle' :text='circleText'></result-circle>
      <p v-if='config.message' class='result-agreement-message'>{{ config.message }}</p>
    </div>
  </div>
  </div>
</template>
<script>
import Circle from './Circle'
import Scoring from '../lib/Scoring.js'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: ['config', 'result'],
  inject: ['theme'],
  mixins: [Scoring, TranslationMixin],
  components: {
    'result-circle': Circle
  },
  data () {
    return {
      componentClasses: ['result-agreement-component', 'result-component'],
      questionText: '',
      progress: 0,
      answer: '',
      ready: false,
      circleTitle: '',
      circleText: ''
    }
  },
  methods: {
    update () {
      this.progress = this.result.agreement.average
      this.circleTitle = (this.progress * 100).toFixed(0) + '%'
    }
  },
  computed: {
    componentStyle () {
      let style = {
        backgroundColor: this.config.backgroundColor,
        color: this.config.textColor
      }
      return style
    },
    circleConfig () {
      return {
        stroke: this.config.resultPrimaryColor || this.theme.progressBar.backgroundColor,
        titleColor: this.config.resultSecondaryColor
      }
    }
  },
  created () {
    this.circleTitle = (this.progress * 100).toFixed(0) + '%'
    this.circleText = ''
    if (this.result.agreement) {
      this.update()
    }
  },
  watch: {
    result: function (newResult, oldResult) {
      this.update()
    }
  }
}
</script>
<style lang='scss'>
  .result-wrapper {

    width: 100%;
    margin: auto;
    .result-data {
      max-width: 400px;
      margin: 0 auto;
    }
  }

</style>
